import React from 'react';
import cx from 'classnames';
import { Button } from 'antd';

import { getServiceAgreementFileInfoForCustomer } from 'redux/reducers/clientSlice';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { downloadFile } from 'utils/fileUtils';
import {
  ServiceAgreementTypeEnum,
  CustomerInfoResponseModel,
} from 'api/backofficeApiClient';
import BaseAlert from 'components/wrappers/BaseAlert';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

import style from './DownloadClientAgreement.module.less';

type Props = {
  client: CustomerInfoResponseModel;
};

export default function DownloadClientAgreement(props: Props) {
  const { client } = props;
  const { customerId, agreementDetails } = client;

  const isAdminRole = useAppSelector(isAdminSelector);
  const dispatch = useAppDispatch();

  const handleDownloadAgreement = async () => {
    const result = await dispatch(
      getServiceAgreementFileInfoForCustomer({
        customerId: customerId as string,
        isAdminRole,
      }),
    );
    if (getServiceAgreementFileInfoForCustomer.fulfilled.match(result)) {
      const { downloadUrl, fileName } = result.payload;
      try {
        await downloadFile({ downloadUrl, fileName });
      } catch (e: any) {
        BaseAlert.error(e.message);
      }
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const getAgreementButtonLabel = () => {
    switch (agreementDetails.agreementDetailsType) {
      case ServiceAgreementTypeEnum.MemberAgreement:
        return 'Download member agreement';

      case ServiceAgreementTypeEnum.ClientAgreement:
      default:
        return 'Download customer agreement';
    }
  };

  return (
    <Button
      className={cx('with-icon borderless-btn', style.btn)}
      onClick={handleDownloadAgreement}
      icon={<span className="icon icon-paperclip" />}
    >
      {getAgreementButtonLabel()}
    </Button>
  );
}
